export default __webpack_public_path__ + "static/media/4R.d4b55dbd.png";